/**
 * What the API client needs to know about offline sessions without importing the
 * session module (which imports the client): the marker of a local session and the hook
 * the session module fills in at start-up.
 */
import type { TokenPair } from '@qrkey/api-client';

export const OFFLINE_TOKEN = 'qrkey-offline-session';

export function isOfflineSession(pair: TokenPair | null): boolean {
  return pair !== null && pair.accessToken === OFFLINE_TOKEN;
}

export const sessionHooks: { upgrade: () => Promise<boolean> } = {
  upgrade: () => Promise.resolve(false),
};
